<template>

  <div>
    <a-modal v-model:visible="visible" :title="'医生详情'" @ok="handleOk" okText="保存" cancelText="返回" :afterClose="closeModal" width="30vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="style1">
          <div class="box">
            <label>名字：</label>
            {{baseInfo.name}}
          </div>
          <div class="box">
            <label>电话：</label>
            {{baseInfo.mobile}}
          </div>
          <div class="box">
            <label>性别：</label>
            {{baseInfo.gender}}
            <!-- <a-select v-model:value="inputs.gender" allowClear>
              <a-select-option value="男">男</a-select-option>
              <a-select-option value="女">女</a-select-option>
            </a-select> -->
          </div>
        </div>
      </a-form>
      <a-menu v-model:selectedKeys="current" mode="horizontal" style="margin-bottom: 30px;" @select="selectMenu">
        <a-menu-item key="baseInfo">
          基本信息
        </a-menu-item>
        <a-menu-item key="intro">
          个人介绍
        </a-menu-item>
        <a-menu-item key="specialty">
          特长
        </a-menu-item>
      </a-menu>
      <a-form v-if="current[0] == 'baseInfo'" :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="style1">
          <div class="box">
            <label>头像：</label>
            <div class="headImgBox">
              <img class="headImg" :src="'/api/file/img/'+inputs.headImage">
              <a-upload v-model:file-list="fileList" name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :custom-request="customRequest" :before-upload="beforeUpload">
                <img v-if="imageUrl" :src="imageUrl" alt="avatar" style="width: 100%; height: 100%; object-fit: cover;" />
                <div v-else>
                  <loading-outlined v-if="loading"></loading-outlined>
                  <plus-outlined v-else></plus-outlined>
                  <div class="ant-upload-text">{{inputs?.headImage ? '更换头像' : '上传头像'}}</div>
                </div>
              </a-upload>
            </div>
          </div>
          <div class="tips">*文件大小不得超过2mb</div>
          <div class="box">
            <label>擅长：</label>
            <a-textarea class="noResize" v-model:value="inputs.expertise" />
          </div>

          <div class="box">
            <label>职称：</label>
            <a-input v-model:value="inputs.title" />
          </div>

          <div class="box">
            <label>个人介绍：</label>
            <a-textarea class="noResize" v-model:value="inputs.introduction" />
          </div>
          <div class="box">
            <label>个人成就：</label>
            <a-textarea class="noResize" v-model:value="inputs.medicalAchievement" />
          </div>
        </div>

      </a-form>
      <a-form v-if="current[0] == 'intro'" :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="style1">

          <div class="box move">
            <div v-for="(item,index) in introList" :key="item">
              <!-- {{item}} -->
              <a-input v-model:value="item.detail" />
              <div>
                <DownOutlined class="btn_down" @click="sortIntroList('up',index)" />
                <UpOutlined class="btn_up" @click="sortIntroList('down',index)" />
                <CloseOutlined class="btn_delete" @click="deleteIntro(index)" />

              </div>
            </div>

          </div>

          <div style="text-align: center;">
            <a-button type="primary" @click="addIntro">新增</a-button>
          </div>
        </div>

      </a-form>
      <a-form v-if="current[0] == 'specialty'" :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="style1">

          <div class="box move">
            <div v-for="(item,index) in specialtyList" :key="item">
              <!-- {{item}} -->
              <a-input v-model:value="item.detail" />
              <div>
                <DownOutlined class="btn_down" @click="sortSpecialtyList('up',index)" />
                <UpOutlined class="btn_up" @click="sortSpecialtyList('down',index)" />
                <CloseOutlined class="btn_delete" @click="deleteSpecialty(index)" />

              </div>
            </div>

          </div>

          <div style="text-align: center;">
            <a-button type="primary" @click="addSpecialty">新增</a-button>
          </div>
        </div>

      </a-form>

    </a-modal>
  </div>
</template>

<script>
import {
  CheckCircleFilled,
  UpOutlined,
  DownOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { EmployeeEdit, SubjectList, EditSubjectObject } from "/src/api/appointment.js";
import { Upload } from "/src/api/upload.js";
// import addPrescription from '/src/components/prescription/addPrescription.vue';
import { cloneDeep } from "lodash-es";

export default {
  components: {
    CheckCircleFilled,
    UpOutlined,
    DownOutlined,
    CloseOutlined
  },
  data() {
    return {
      id: "",
      current: ['baseInfo'],
      introId: "",
      specialtyId: "",
      visible: this.modelValue,
      showTable: 0,
      introList: [],
      specialtyList: [],
      medicineFilter: "",
      title: "",
      inputs: {},
      baseInfo: {},
      prescription: "",
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      selectedRow: {},
      editableData: {},
      fileList: [],
    };
  },
  emits: ['update:modelValue'],
  created() {
  },
  mounted() {
    this.init()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    record: {
      type: Object,
      default: {},
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  computed: {
  },
  methods: {
    init() {
      // 把record赋值给inputs
      this.inputs = {}
      this.inputs = { ...this.record }
      this.baseInfo = { ...this.record }
      console.log("初始化", this.inputs);
      this.detail()

    },
    async selectMenu() {
      if (this.current[0] == 'baseInfo') {
        this.inputs = this.record
      } else if (this.current[0] == 'intro') {
        this.inputs = this.introList
      } else if (this.current[0] == 'specialty') {
        this.inputs = this.specialtyList
      }
      console.log("选中menu", this.inputs);

    },

    async addSubject() {
      // let res = await AddSubjectObject({ doctorId: this.id, subjectId: this.current[1] })
    },
    showModal() {
      this.visible = true
    },
    async detail() {
      if (!this.record.id) {
        return
      }
      let res = await SubjectList({
        objectId: this.record.id,
        objectCategory: "员工",
        category: "医生附加信息"
      })
      this.formatintroList(res)
      this.formatSpecialtyList(res)
    },
    closeModal() {
      this.$emit('update:modelValue', false);
      this.record = {}
      this.inputs = {}
    },
    formatintroList(res) {
      this.introList = res.data.find(item => item.name == '个人信息').items ? res.data.find(item => item.name == '个人信息').items : []
      this.introId = res.data.find(item => item.name == '个人信息').id
    },
    formatSpecialtyList(res) {
      this.specialtyList = res.data.find(item => item.name == '特长').items ? res.data.find(item => item.name == '特长').items : []
      this.specialtyId = res.data.find(item => item.name == '特长').id
    },
    async handleOk() {

      if (this.current[0] == 'baseInfo') {
        let res = await EmployeeEdit({ ...this.inputs })
        if (res.errCode == 0) {
          this.$message.success("修改成功", function () { });
          this.visible = false
          this.$emit('reSearch');
          // this.inputs = {}
        }
      } else if (this.current[0] == 'intro') {
        let res = await EditSubjectObject({
          id: this.introId,
          items: this.introList
        })
        // console.log(res);
        // this.formatintroList(res)
        this.detail()

      } else if (this.current[0] == 'specialty') {
        let res = await EditSubjectObject({
          id: this.specialtyId,
          items: this.specialtyList
        })
        // console.log(res);
        // this.sortSpecialtyList(res)
        this.detail()

      }


    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只支持 JPG/PNG 格式!');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }

      // 清空 fileList，只保留当前上传的文件
      this.fileList = [];
      this.imageUrl = '';
      return true; // 继续上传
    },
    async customRequest({ file, onSuccess, onError }) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('category', 'portrait');
      formData.append('system', 'true');

      let res = await Upload(formData); // 调用你封装的 Upload 方法
      console.log(res.data);
      this.inputs.headImage = res.data
      console.log("this.inputs", this.inputs);


    },
    sortIntroList(type, index) {
      const list = this.introList;
      if (type === 'down' && index > 0) {
        // 向上：和前一个交换
        [list[index], list[index - 1]] = [list[index - 1], list[index]];
      } else if (type === 'up' && index < list.length - 1) {
        // 向下：和后一个交换
        [list[index], list[index + 1]] = [list[index + 1], list[index]];
      }
    },
    addIntro() {
      this.introList.push({ detail: '' });
    },
    deleteIntro(index) {
      this.introList.splice(index, 1)
    },
    sortSpecialtyList(type, index) {
      const list = this.specialtyList;
      if (type === 'down' && index > 0) {
        // 向下：和后一个交换
        [list[index], list[index - 1]] = [list[index - 1], list[index]];
      } else if (type === 'up' && index < list.length - 1) {

        // 向上：和前一个交换
        [list[index], list[index + 1]] = [list[index + 1], list[index]];
      }
    },
    addSpecialty() {
      this.specialtyList.push({ detail: '' });
    },
    deleteSpecialty(index) {
      this.specialtyList.splice(index, 1)
    }

  },
  watch: {
    record(val) {
      this.init()
    },
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.thead {
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.5em;
}
.style1 {
  position: relative;
}
.style1 > .box {
  padding-left: 5%;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.box label {
  width: 20%;
}

.box .ant-select,
.box .ant-input,
.box .ant-input-number,
.box .ant-input-textarea {
  width: 70%;
}
.tips {
  color: #999;
  font-size: 12px;
  text-align: center;
  margin-bottom: 10px;
}
.headImgBox {
  display: flex;
}
.headImg {
  width: 100px;
  height: 100px;
  display: inline-block;
  border-radius: 10px;
}
.headImgBox .avatar-uploader {
  width: fit-content;
  margin-left: 20px;
}
.box.move {
  display: block;
}
.move > div {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.move > div .ant-input {
  margin-bottom: 0;
  width: 70%;
  margin-right: 20px;
}
.btn_up,
.btn_down,
.btn_delete {
  margin-left: 10px;
}
.btn_up {
  color: #52c41a;
}
.btn_down {
  color: #fa8c16;
}
.btn_delete {
  color: #ff4444;
}
</style>
